import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";


const Landing = () => {
  const { ref: textRef, inView: textInView } = useInView({
    triggerOnce: false,
    threshold: 0.3,
  });

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, delay: 0.8 } },
  };

  return (
    <div className="bg-gray-50">
      <section className="relative h-screen flex items-center justify-center text-center">
        <div
          className="absolute inset-0 bg-cover bg-center hidden lg:block"
          style={{
            backgroundImage: `url('../landing.jpg')`, // Replace with your desktop image URL
          }}
        ></div>
        <div
          className="absolute inset-0 bg-cover bg-center block lg:hidden"
          style={{
            backgroundImage: `url('../landing.jpg')`, // Replace with your mobile image URL
          }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Text Content */}
        <motion.div
          className="relative z-10 text-white px-4"

          // initial={{ opacity: 0, y: 50 }}
          // animate={{ opacity: 1, y: 0 }}
          initial="hidden"
          animate={textInView ? "visible" : "hidden"}
          ref={textRef}
          variants={textVariants}
          transition={{ duration: 1.3, delay: 1 }}
        >
          <h1 className="text-4xl sm:text-5xl font-serif mb-4">Welcome to <span className="text-8xl font-bold font-serif block sm:text-9xl">Zenetix</span> IT Solutions</h1>
          <p className="text-lg font-medium">
            Your trusted partner for innovative IT solutions and services.
          </p>
        </motion.div>
      </section>


      
    </div>
  );
};

export default Landing;
